import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input, ElementRef } from '@angular/core';
var ActionDialogComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function ActionDialogComponent(element) {
        /**
         * Set our default values
         */
        this.localState = { value: '' };
        this.element = element;
        this.close();
    }
    ActionDialogComponent.prototype.ngAfterContentInit = function () {
    };
    ActionDialogComponent.prototype.close = function () {
        this.element.nativeElement.style.display = 'none';
    };
    ActionDialogComponent.prototype.open = function () {
        this.element.nativeElement.style.display = 'block';
    };
    ActionDialogComponent.prototype.handleNo = function () {
        this.close();
        if (this.onNo) {
            this.onNo();
        }
    };
    ActionDialogComponent.prototype.handleYes = function () {
        this.close();
        if (this.onYes) {
            this.onYes();
        }
    };
    return ActionDialogComponent;
}());
export { ActionDialogComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/action-dialog/action-dialog.component.ts
// module id = null
// module chunks = 